import { queryOptions } from '@tanstack/react-query';
import type { ListNotificationsParams } from '@/modules/notifications/types';
import { notificationsService } from './notifications.service';
import { notificationQueryKeys } from './notifications.query-key';

/** No realtime transport exists, so the feed polls. ~45s keeps the prompt cache
 *  warm-ish and the badge fresh without hammering the API. */
const POLL_INTERVAL_MS = 45_000;

export const notificationQueryOptions = {
    list: (params: ListNotificationsParams = {}) => queryOptions({
        queryKey:        notificationQueryKeys.list(params),
        queryFn:         () => notificationsService.list(params),
        refetchInterval: POLL_INTERVAL_MS,
        staleTime:       15_000,
    }),
};
